// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1785614152835
      var cssReload = require("../node_modules/.pnpm/@umijs+bundler-webpack@4.6.79_typescript@5.9.3_webpack@5.108.4_lightningcss@1.32.0_postcss@8.5.19_/node_modules/@umijs/bundler-webpack/compiled/mini-css-extract-plugin/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"./","emit":true,"esModule":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  